module.exports = __webpack_public_path__ + "static/media/channel=url shortner.231d4e61.svg";